import React from 'react'

import { connect } from "react-redux"

// need to use withRouter higher order component to access the routing history since the Lobbyist actions isn't a route
// we could pass in as props from parent but this makes it stand alone
import { withRouter } from 'react-router'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import ConfirmDialog from '../components/common/ConfirmDialog'
import ChangesRequiredDialog from '../components/lobbyist/changes-required-dialog'

import { ANNUAL_RETURN_STATUS_AWAITING_SUBMIT, ANNUAL_RETURN_STATUS_AWAITING_APPROVAL,ANNUAL_RETURN_STATUS_APPROVED, ANNUAL_RETURN_TYPE_FINAL, ROLE_ADMIN } from '../js/const'

import * as annualReturnActionCreators from "../actionCreators/annualReturn"
import * as lobbyistActionCreators from "../actionCreators/lobbyist"
import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"

class AnnualReturnActions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowingChangesRequiredDialog: false
    }
  }

  goToLobbyist = () => {
    let lobbyistId = this.props.match.params.lobbyistId
    this.props.history.push('/lobbyist/' + lobbyistId)
  }

  // fourth step is for internal users to approve the lobbyist
  approve = (lobbyistId, annualReturnId) => {
    this.props.setLoading(true)
      .then(() => {
        this.props.approveAnnualReturn(lobbyistId, annualReturnId)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  delete = (lobbyistId, annualReturnId) => {
    this.props.setLoading(true)
      .then(() => this.props.deleteAnnualReturn(annualReturnId))
      .then(response => {
        // set response in store so global response component can handle response
        this.props.setAjaxResponse(response)
        if (response.data.Success) {
          this.props.history.push('/lobbyist/' + lobbyistId)
        }
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  reject =  (lobbyistId, annualReturnId) => {
    this.props.setLoading(true)
    .then(() => this.props.rejectFinalAnnualReturn(lobbyistId,annualReturnId))
    .then(response => {
      // set response in store so global response component can handle response
      this.props.setAjaxResponse(response)
      if (response.data.Success) {
        this.props.history.push('/lobbyist/' + lobbyistId)
      }
    })
    .then(() => this.props.setLoading(false))
    .catch((error) => this.props.handleError(error)
      .then(() => this.props.setLoading(false)))
  }

  closeChangesRequired = () => this.setState({ isShowingChangesRequiredDialog: false })

  showChangesRequired = annualReturnId => {
    this.props.setLoading(true)
      .then(() => this.props.getChangesRequired(annualReturnId))
      .then(() => {
        this.setState({ isShowingChangesRequiredDialog: true })
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

    // fourth step is for internal users can request changes
    changesRequiredFormSubmitted = annualReturn => {
      this.props.setLoading(true)
        .then(() => {
          this.props.changesRequired(annualReturn)
            .then(response => {
              this.props.setAjaxResponse(response)
              this.props.setLoading(false)
            })
        })
        .catch((error) => this.props.handleError(error)
          .then(() => this.props.setLoading(false)))
    }

  render() {
    // check if current annualReturn that is being looked at exists. If not create an empty object to deal with issues that could be caused by annualReturn being undefined
    let currentAnnualReturn = this.props.annualReturn.currentAnnualReturn ? this.props.annualReturn.currentAnnualReturn : {}
    let changesRequired = this.props.annualReturn.changesRequired ? this.props.annualReturn.changesRequired : {}

    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdd = !currentAnnualReturn.AnnualReturnId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)

    let isAwaitingSubmission = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_AWAITING_SUBMIT
    let isAwaitingApproval = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_AWAITING_APPROVAL
    let isApproved = currentAnnualReturn.StatusCode === ANNUAL_RETURN_STATUS_APPROVED

    let isCorrectLobbyist = currentAnnualReturn.LobbyistId === this.props.auth.lobbyistId
  
    let canSubmit = isAdd === false && isAuthenticated === true && (isCorrectLobbyist || isAdmin === true) && isAwaitingSubmission
    let canApprove = isAdd === false && isAuthenticated === true && isAdmin === true && isAwaitingApproval
    let canDelete = isAdd === false && ((isAdmin === true && isAwaitingApproval === false) || (isAdmin === false && isAwaitingSubmission === true))
    let canRequestChanges = isAdd === false && isAuthenticated === true && isAdmin === true && isAwaitingApproval
    let canReject = isAdd === false && isAuthenticated === true && isAdmin === true && isAwaitingApproval && currentAnnualReturn.TypeCode === ANNUAL_RETURN_TYPE_FINAL
    let canUpdate = isAdd === false && isAuthenticated === true && isApproved &&  isAdmin === true

    let approveLabel = currentAnnualReturn.TypeCode === ANNUAL_RETURN_TYPE_FINAL ? 'Approve Final Return and Surrender' : 'Approve'
    let submitLabel = currentAnnualReturn.TypeCode === ANNUAL_RETURN_TYPE_FINAL ? 'Submit Surrender Request' : 'Submit'
    let deleteLabel = currentAnnualReturn.TypeCode === ANNUAL_RETURN_TYPE_FINAL && (isAwaitingSubmission || isAwaitingApproval) ? 'Cancel Surrender Request' : 'Delete'
    let deleteMessage = currentAnnualReturn.TypeCode === ANNUAL_RETURN_TYPE_FINAL && (isAwaitingSubmission || isAwaitingApproval) ? 'Are you sure you wish to cancel the surrender request?' : 'Are you sure you wish to delete this annual return?'
    let rejectLabel = 'Reject Surrender'
    let rejectMessage = 'Are you sure you wish to reject the surrender request?'
    let updateLabel = 'Save Update'

    return (
      <React.Fragment>
        <Toolbar>
          <div className="p-toolbar-group-left">
            {canUpdate && <Button label={updateLabel} icon="pi pi-check" className="p-button-success" onClick={() => this.props.formApi.submitForm()} />}
            {canSubmit && <Button label={submitLabel} icon="pi pi-check" className="p-button-success" onClick={() => this.props.formApi.submitForm()} />}
            {canApprove && <Button label={approveLabel} icon="pi pi-check" className="p-button-success" onClick={() => this.approve(currentAnnualReturn.LobbyistId, currentAnnualReturn.AnnualReturnId)} />}
            {canRequestChanges && <Button label="Changes Required" icon="pi pi-exclamation-triangle"
              className="p-button-warning" onClick={() => this.showChangesRequired(currentAnnualReturn.AnnualReturnId)} />}
            <Button label="Back to Lobbyist" className="p-button-secondary" onClick={this.goToLobbyist} />
          </div>
          <div className="p-toolbar-group-right">
              {canDelete && <ConfirmDialog buttonLabel={deleteLabel} buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.delete(currentAnnualReturn.LobbyistId, currentAnnualReturn.AnnualReturnId)}
              title={`Confirm ${deleteLabel}`} message={deleteMessage} />}
              {canReject && <ConfirmDialog buttonLabel={rejectLabel} buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() =>  this.reject(currentAnnualReturn.LobbyistId,currentAnnualReturn.AnnualReturnId)}
              title={`Confirm ${rejectLabel}`} message={rejectMessage}/>}
          </div>
        </Toolbar>
        {canRequestChanges && <ChangesRequiredDialog isShowingChangesRequiredDialog={this.state.isShowingChangesRequiredDialog} changesRequired={changesRequired}
        changesRequiredFormSubmitted={this.changesRequiredFormSubmitted} closeChangesRequired={this.closeChangesRequired} currentAnnualReturn={currentAnnualReturn}></ChangesRequiredDialog>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

// this is how to combine actions available
const actionCreators = {
  ...annualReturnActionCreators,
  ...lobbyistActionCreators,
  ...appActionCreators,
  ...authActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(AnnualReturnActions))


// WEBPACK FOOTER //
// ./src/container/AnnualReturnActions.js